@if (design4) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="DESIGN_2"></ng-container>
}
<ng-template #DESIGN_4>
  <div class="page-content" fxLayout="column" fxLayoutAlign="start start">
    @if (!cardOnFile) {
      <div fxLayout="column" fxLayout.gt-sm="row" class="progress-wrapper">
        <app-create-progress fxFlex [step]="flowStep" [flowConfiguration]="flowConfiguration" />
      </div>
    }
    @if (isLoading) {
      <div class="payment-instructions step-content" flexLayout="row" fxLayoutAlign="center center" style="height: 100%; width: 100%">
        <mat-spinner />
      </div>
    }
    @if (!isLoading && !expired) {
      <div class="payment-instructions step-content" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.lt-md="start start">
        <div class="payment-content" fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="start start" fxLayoutAlign.lt-md="start center">
          <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100" fxFlex.gt-sm="50" style="width: 100%" fxLayoutGap="15px">
            @if (lead?.isUberPickup) {
              <div>
                <div class="quote-expiration-timer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                  <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
                    <img src="assets/images/clock.svg" alt="Timer" />
                    <countdown
                      class="main-countdown"
                      (event)="quoteExpired($event)"
                      [config]="{ leftTime: leftTime, formatDate: formatLeftTime }"
                    ></countdown>
                  </div>
                  <span>
                    Your request is valid until this timer expires. After that, our availability in your area may change, and we’ll need to
                    refresh your reservation.
                  </span>
                </div>
              </div>
            }
            <div
              class="order-details"
              [ngClass]="{ courier: lead?.isUberPickup, discounted: lead?.quote?.discount_amount > 0 }"
              fxLayout="column"
              fxLayoutAlign="start center"
            >
              @if (lead?.discount?.valid && showCOFform) {
                <div class="discount-badge" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                  <span>
                    <b>You got {{ sponsorshipPercent }}% Off</b>
                  </span>
                  <div fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="center center">
                    <span>Sponsored by</span>
                    <img src="{{ charity?.logo }}" alt="{{ charity?.name }}" />
                  </div>
                </div>
              }
              <div>
                <div class="order-preview">
                  <h2 style="margin-top: 0">Donation Preview</h2>
                  <div style="margin-bottom: 15px" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                      <span>Pickup date & time</span>
                      <span class="highlighted-value">
                        {{ lead?.date | date: 'EEEE, MMMM d' }} -
                        {{
                          lead?.hour_slot
                            ? _24hTo12h(lead.hour_slot) + ':00 ' + lead?.partOfDay?.toUpperCase()
                            : lead?.partOfDay?.toUpperCase()
                        }}
                      </span>
                    </div>
                    <button class="primary-btn" [routerLink]="['/', 'place-time', flowType, flowId]">Edit</button>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="column">
                      <span>Pickup address</span>
                      <span class="highlighted-value">{{ lead?.address.fullAddress }}</span>
                    </div>
                    <button class="primary-btn" [routerLink]="['/', 'place-time', flowType, flowId]">Edit</button>
                  </div>
                </div>
                <div fxLayout="row" fxFlex="100">
                  @if (lead) {
                    <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
                      @if (lead?.isUberPickup) {
                        @if (showCOFform) {
                          <div fxLayout="row" fxLayoutAlign="space-between" class="courier-total-cost" fxFlex="100">
                            <span>Total Cost of Service</span>
                            <div>
                              @if (lead?.totalSponsoredAmount > 0) {
                                <span>{{ lead?.total - lead?.totalSponsoredAmount + gratuity | currency }}</span>
                                <span class="discounted-value">{{ lead?.total | currency }}</span>
                              } @else {
                                <span>{{ lead?.total + gratuity | currency }}</span>
                              }
                            </div>
                          </div>
                        }
                      } @else if (lead && pricing && lead?.specification) {
                        <rspl-donation-estimate
                          fxFlex="100"
                          type="initial"
                          [pricing]="pricing"
                          [specification]="lead?.specification"
                          [showZeros]="false"
                          [editable]="charity?.meta?.onlySmallItems || !paymentSetupInitialized ? false : true"
                          [showUnitPrices]="false"
                          [bookingFee]="lead?.pricing.bookingFee"
                          [showTodaysCharges]="!lead?.discount?.valid"
                          [showDiscount]="lead?.discount?.valid"
                          [leadOrDonation]="lead"
                          (onSpecificationChange)="onSpecificationChange()"
                          totalLabel="Estimated Pickup Cost (Due On-Site)"
                          bookingLabel="Booking Fee (Due Today)"
                          [isCalculating]="isCalculatingPrice"
                          [edit]="editSpecification.bind(this)"
                        ></rspl-donation-estimate>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <!--  ********************************** TIP ********************************  -->
            @if (lead?.isUberPickup) {
              <div fxLayout="column" class="tip" fxLayoutGap="15px">
                <div fxLayout="column" fxLayoutAlign="start start">
                  <h2 style="margin-top: 0">Add a tip?</h2>
                  <div fxLayout="row" fxLayoutAlign="start start" fxFlex="100" class="tips" fxLayoutGap="4px">
                    <button
                      fxFlex="25"
                      class="primary-btn"
                      (click)="toggleTip(tipTypes.NO_TIP)"
                      [ngClass]="{ 'filled-btn': tip === tipTypes.NO_TIP }"
                    >
                      No Tip
                    </button>
                    <button
                      fxFlex="25"
                      class="primary-btn"
                      (click)="toggleTip(tipTypes.FIVE)"
                      [ngClass]="{ 'filled-btn': tip === tipTypes.FIVE }"
                    >
                      $ 5
                    </button>
                    <button
                      fxFlex="25"
                      class="primary-btn"
                      (click)="toggleTip(tipTypes.TEN)"
                      [ngClass]="{ 'filled-btn': tip === tipTypes.TEN }"
                    >
                      $ 10
                    </button>
                    <button
                      fxFlex="25"
                      class="primary-btn"
                      (click)="toggleTip(tipTypes.FIFTEEN)"
                      [ngClass]="{ 'filled-btn': tip === tipTypes.FIFTEEN }"
                    >
                      $ 15
                    </button>
                  </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="start start">
                  <div
                    fxFlex
                    class="custom-tip"
                    (click)="toggleCustom($event, inputElement)"
                    [ngClass]="{ selected: tip === tipTypes.CUSTOM }"
                  >
                    <div class="form-row" fxLayout="column" style="position: relative">
                      <label>Custom tip amount:</label>
                      <input #inputElement name="custom-tip" type="text" [(ngModel)]="customGratuity" matInput currencyMask />
                      @if (tip === tipTypes.CUSTOM && gratuity !== customGratuity) {
                        <div style="position: absolute; right: 0; top: 23px; height: 45px; z-index: 1">
                          <div fxLayout="row" fxLayoutAlign="center center" style="height: 41px; padding-right: 4px">
                            <button
                              class="primary-btn"
                              (click)="$event.stopPropagation(); $event.preventDefault(); customGratuity = gratuity; setGratuity()"
                            >
                              Cancel
                            </button>
                            <button class="primary-btn filled-btn" (click)="setCustomTip($event)">Apply</button>
                          </div>
                        </div>
                      }
                      @if (showTipError && ((tip === tipTypes.CUSTOM && customGratuity < 0.5) || customGratuity > 20)) {
                        <label style="color: var(--error); position: absolute; left: 0; bottom: -23px">
                          Tip must be between $0.50 and $20.00
                        </label>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
          <!--  ********************************** desktop RIGHT section start ********************************  -->
          <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="15px" fxFlex="100" fxFlex.gt-sm="50" style="width: 100%">
            <div fxLayout="column" fxLayoutGap="4px">
              <ng-container [ngTemplateOutlet]="Checkbox"></ng-container>
              @if (showCOFform || gratuity) {
                <div [ngClass]="{ 'stripe-wrarapper': showCOFform || gratuity }">
                  <h3>Enter payment details</h3>
                  <ng-container [ngTemplateOutlet]="STRIPE"></ng-container>
                  @if (isLoaded) {
                    <div
                      fxLayoutAlign="center center"
                      fxLayout="column"
                      class="submit-button-wrapper"
                      [ngStyle]="{ 'margin-top.px': showCOFform || gratuity ? 0 : 50 }"
                    >
                      <button
                        class="submit-button primary-page-btn success-btn btn-block"
                        id="submitDonationButton"
                        (click)="confirmPayment()"
                        [ladda]="isSubmitting"
                        [disabled]="!isLoaded && (showCOFform || gratuity > 0)"
                      >
                        Confirm Payment
                      </button>
                      @if (showCOFform || gratuity) {
                        <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px" class="powered-by">
                          <mat-icon class="stripe-icon" svgIcon="stripe" />
                          <span>All transactions are secure and encrypted.</span>
                          <span>Secure payments through Stripe</span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            @if (!(showCOFform || gratuity)) {
              <div fxLayoutAlign="center center" fxLayout="column" class="submit-button-wrapper">
                <button
                  class="submit-button primary-page-btn success-btn btn-block"
                  id="submitDonationButton"
                  (click)="confirmPayment()"
                  [ladda]="isSubmitting"
                  [disabled]="!isLoaded && (showCOFform || gratuity > 0)"
                >
                  <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap="15px">
                    <span>Submit</span>
                    <mat-icon>arrow_forward</mat-icon>
                  </div>
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    }
    <div class="error-wrapper" fxLayoutAlign="center center">
      @if (error && !expired) {
        <p class="error">{{ error }}</p>
      }
      @if (expired) {
        <p class="error expired">Your link has expired, please contact support to get a new link</p>
      }
    </div>
    <app-page-footer
      [hasBack]="hasBack && !cardOnFile"
      [hideContinue]="true"
      [showScrollToPayment]="true"
      (onBack)="back()"
      (onSubmit)="scrollToCheckbox()"
    ></app-page-footer>
  </div>
</ng-template>

<ng-template #Checkbox>
  <div fxLayout="column" class="checkboxes checkbox-container">
    <div class="form-row form-row-checkbox" fxLayout="row" fxLayoutAlign="start start" fxFlex.gt-sm="50" fxPosition="static">
      <input type="checkbox" id="userTerms" name="userTerms" [(ngModel)]="userTerms" />
      <button class="checkbox" (click)="onCheckboxChange()" [ngClass]="{ invalid: !userTerms && showErrors }">
        @if (userTerms) {
          <mat-icon svgIcon="checkmark" />
        }
      </button>
      <label
        [ngClass]="{
          invalid: !userTerms && showErrors,
          'is-courier': lead?.isUberPickup,
        }"
        for="userTerms"
      >
        @if (!lead?.isUberPickup && (lead?.pricing.bookingFee || 0) > 0) {
          <b>I understand my card is only being charged a {{ lead?.pricing.bookingFee || 0 | currency }} reservation fee at this time.</b>
        }
        @if (!lead?.isUberPickup && (lead?.pricing.bookingFee || 0) === 0) {
          <b>I understand my card will not be charged at this time.</b>
        }
        @if (!lead?.isUberPickup && lead?.quote?.total_amount - lead?.quote?.discount_amount === 0) {
          <span>
            Please keep in mind that while the price shown for your pickup is free, this is just an estimate. Your driver will assess your
            items on-site to determine the cost, which may result in an increase to your final quote.
          </span>
        }
        @if (!lead?.isUberPickup) {
          <span>
            The final cost of the donation pickup will be charged once my donations have been delivered to the
            {{ (charity || lead?.charity)?.name || 'charity' }}.
          </span>
        }
        @if (!lead?.isUberPickup && (lead?.pricing.bookingFee || 0) > 0) {
          If I cancel my donation, the
          {{ lead?.pricing.bookingFee || 0 | currency }} reservation fee is not refundable. If ReSupply is unable to complete my donation
          pickup, the reservation fee can be refunded by contacting ReSupply support.
        }
        @if (lead && !showCOFform) {
          I understand that {{ lead?.charity?.name }} is generously covering the full cost of my donation pickup, so no payment will be
          required from me. If I cancel my donation pickup, a small cancellation fee may be charged to {{ lead?.charity?.name }}.
        }
        I agree to
        <a href="https://resupplyme.com/utility/donor-priority-pickups-terms-of-use" target="_blank">ReSupply's Terms and Conditions</a>
        and to be contacted by Resupply Inc. via SMS text message with updates about my donation pickup (standard message rates may apply).
      </label>
      @if (!userTerms && showErrors && lead?.isUberPickup && !isSmallWindowSize) {
        <p
          class="invalid terms-validation-error is-courier"
          fxLayout="row"
          fxLayoutGap="2px"
          fxLayoutAlign="center center"
          fxPosition="absolute"
        >
          <mat-icon>info_outline</mat-icon>
          <span>Check this box to agree to the Terms & Conditions</span>
        </p>
      }
    </div>
  </div>
</ng-template>

<ng-template #STRIPE>
  @if (
    (estimate() || lead?.isUberPickup) &&
    flowService.paymentIntent &&
    flowService.paymentIntent.client_secret &&
    (showCOFform || gratuity > 0)
  ) {
    <rspl-stripe
      [paymentIntent]="flowService.paymentIntent"
      (onReady)="cardReady($event)"
      [type]="
        !!flowService.paymentIntent.booking_fee ||
        (flowService.lead?.quote?.courier === courierTypes.UBER &&
          (flowService.lead?.quote?.total_amount || 0) - (flowService.lead?.quote?.discount_amount || 0) + gratuity > 0)
          ? 'payment'
          : 'setup'
      "
      (onSuccess)="paymentSuccess()"
      (onError)="onPaymentError($event)"
      [total]="{
        amount:
          (flowService.lead?.quote?.courier === courierTypes.UBER
            ? flowService.lead?.quote?.total_amount
            : flowService.paymentIntent.booking_fee
              ? flowService.lead?.pricing.bookingFee || 0
              : estimate()
                ? estimate().donationPrice
                : lead.total || 0) * 100,
        label: 'Total Cost',
      }"
      [newCard]="true"
      [disableButtons]="!userTerms"
      (onDisabledButtonsClicked)="disabledButtonsClicked()"
      (onPaymentSetupSuccess)="onPaymentSetupSuccess($event)"
    ></rspl-stripe>
  }
</ng-template>

<ng-template #DESIGN_2>
  <app-page-header
    [charity]="charity"
    [territory]="organization"
    title="Reserve your donation pickup."
    [subtitle]="showCOFform ? 'Total estimate to be finalized on site' : ' '"
    [hasBack]="hasBack && !cardOnFile"
    (onBack)="back()"
  ></app-page-header>
  <div class="page-content" fxLayout="column" fxLayoutAlign="start start">
    @if (isLoading) {
      <div class="payment-instructions step-content" flexLayout="row" fxLayoutAlign="center center" style="height: 100%; width: 100%">
        <mat-spinner />
      </div>
    }
    @if (!isLoading && !expired) {
      <div class="payment-instructions step-content" fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.lt-md="start start">
        <div
          class="payment-content"
          fxLayout="column"
          fxLayout.gt-sm="row"
          fxLayoutAlign="start start"
          fxLayoutAlign.lt-md="start center"
          fxLayoutGap.lt-md="10px"
          fxLayoutGap="30px"
        >
          <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="60" style="width: 100%">
            @if (lead?.isUberPickup) {
              <div class="quote-expiration-timer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <img src="assets/images/clock.svg" alt="Timer" />
                <countdown
                  class="main-countdown"
                  (event)="quoteExpired($event)"
                  [config]="{ leftTime: leftTime, formatDate: formatLeftTime }"
                ></countdown>
                <span>
                  Your request is valid until this timer expires. After that, our availability in your area may change, and we’ll need to
                  refresh your reservation.
                </span>
              </div>
            }

            <div class="order-preview" [ngClass]="{ courier: lead?.isUberPickup }">
              <h2 style="margin-top: 0">Order preview</h2>
              <div style="margin-bottom: 15px" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="column">
                  <span><b>Pickup date & time</b></span>
                  <span>
                    {{ lead?.date | date }} -
                    {{
                      lead?.hour_slot ? _24hTo12h(lead.hour_slot) + ':00 ' + lead?.partOfDay?.toUpperCase() : lead?.partOfDay?.toUpperCase()
                    }}
                  </span>
                </div>
                <button class="primary-btn" [routerLink]="['/', 'place-time', flowType, flowId]">Change</button>
              </div>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="column">
                  <span><b>Pickup address</b></span>
                  <span>{{ lead?.address.fullAddress }}</span>
                </div>
                <button class="primary-btn" [routerLink]="['/', 'place-time', flowType, flowId]">Change</button>
              </div>
            </div>
            @if (lead?.discount?.valid && showCOFform) {
              <div fxLayout="row" fxLayoutAlign="end" style="width: 100%">
                <div class="discount-badge" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                  <div fxLayout="column">
                    <span>
                      <b>You got {{ sponsorshipPercent }}% Off</b>
                    </span>
                    <span>Sponsored by</span>
                  </div>
                  <img src="{{ charity?.logo }}" alt="{{ charity?.name }}" />
                </div>
              </div>
            }
            <div fxLayout="row" fxFlex="100">
              @if (lead) {
                <div fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
                  @if (!showQuoteDetails && estimate() && !lead?.isUberPickup) {
                    <button
                      class="primary-btn filled-btn quote-details-btn btn-block"
                      (click)="showQuoteDetails = true"
                      [ngClass]="{
                        hidden: !isSmallWindowSize,
                        discounted: lead?.discount?.valid,
                      }"
                    >
                      Show Cost Breakdown:
                      {{ (estimate().donationPrice || 0) - sponsoredAmount + (estimate().bookingFee || 0) | currency }}
                    </button>
                  }
                  @if (!showQuoteDetails && isSmallWindowSize && !lead?.isUberPickup) {
                    <div class="estimated-pickup-cost" fxFlexAlign="space-between">
                      <span style="margin-bottom: 4px; line-height: 14px">
                        Estimated Pickup Cost
                        <br />
                        (Due On-Site)
                        @if (lead?.discount?.valid) {
                          <img (click)="showDiscountInfoDialog()" class="discount-info-ic" src="/assets/images/info.svg" />
                        }
                      </span>
                      <div fxLayout="row">
                        <span>{{ donationPrice - sponsoredAmount | currency }}</span>
                        @if (lead?.discount?.valid) {
                          <span class="discounted-value">
                            {{ donationPrice | currency }}
                          </span>
                        }
                      </div>
                    </div>
                  }
                  @if (!showQuoteDetails && isSmallWindowSize && !lead?.isUberPickup) {
                    <div class="todays-charges" fxFlexAlign="space-between">
                      <span>Today's Charges</span>
                      <span>{{ lead?.pricing.bookingFee || 0 | currency }}</span>
                    </div>
                  }

                  <!--  ********************************** desktop LEFT section start ********************************  -->
                  @if (lead?.isUberPickup) {
                    @if (showCOFform) {
                      <div fxLayout="row" fxLayoutAlign="space-between" class="courier-total-cost" fxFlex="100">
                        <span>Total Cost of Service</span>
                        <div>
                          @if (lead?.totalSponsoredAmount > 0) {
                            <span>{{ lead?.total - lead?.totalSponsoredAmount + gratuity | currency }}</span>
                            <span class="discounted-value">{{ lead?.total | currency }}</span>
                          } @else {
                            <span>{{ lead?.total + gratuity | currency }}</span>
                          }
                        </div>
                      </div>
                    }
                    <div fxLayout="column" class="tip" fxLayoutGap="15px">
                      <div fxLayout="column" fxLayoutAlign="start start">
                        <h2 style="margin-top: 0">Tip</h2>
                        <div fxLayout="row" fxLayoutAlign="start start" fxFlex class="tips">
                          <button
                            fxFlex
                            class="primary-btn"
                            (click)="toggleTip(tipTypes.NO_TIP)"
                            [ngClass]="{ 'filled-btn': tip === tipTypes.NO_TIP }"
                          >
                            No Tip
                          </button>
                          <button
                            fxFlex
                            class="primary-btn"
                            (click)="toggleTip(tipTypes.FIVE)"
                            [ngClass]="{ 'filled-btn': tip === tipTypes.FIVE }"
                          >
                            {{ 5 | currency }}
                          </button>
                          <button
                            fxFlex
                            class="primary-btn"
                            (click)="toggleTip(tipTypes.TEN)"
                            [ngClass]="{ 'filled-btn': tip === tipTypes.TEN }"
                          >
                            {{ 10 | currency }}
                          </button>
                          <button
                            fxFlex
                            class="primary-btn"
                            (click)="toggleTip(tipTypes.FIFTEEN)"
                            [ngClass]="{ 'filled-btn': tip === tipTypes.FIFTEEN }"
                          >
                            {{ 15 | currency }}
                          </button>
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="start start">
                        <div
                          fxFlex
                          class="custom-tip"
                          (click)="toggleCustom($event, inputElement)"
                          [ngClass]="{ selected: tip === tipTypes.CUSTOM }"
                        >
                          <div class="form-row" fxLayout="column" style="position: relative">
                            <label>Custom tip amount:</label>
                            <input #inputElement name="custom-tip" type="text" [(ngModel)]="customGratuity" matInput currencyMask />
                            @if (tip === tipTypes.CUSTOM && gratuity !== customGratuity) {
                              <div style="position: absolute; right: 0; top: 23px; height: 45px; z-index: 1">
                                <div fxLayout="row" fxLayoutAlign="center center" style="height: 41px; padding-right: 4px">
                                  <button
                                    class="primary-btn"
                                    (click)="$event.stopPropagation(); $event.preventDefault(); customGratuity = gratuity; setGratuity()"
                                  >
                                    Cancel
                                  </button>
                                  <button class="primary-btn filled-btn" (click)="setCustomTip($event)">Apply</button>
                                </div>
                              </div>
                            }
                            @if (showTipError && ((tip === tipTypes.CUSTOM && customGratuity < 0.5) || customGratuity > 20)) {
                              <label style="color: var(--error); position: absolute; left: 0; bottom: -23px">
                                Tip must be between $0.50 and $20.00
                              </label>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }

                  <div
                    fxLayout="column"
                    fxLayout.gt-xs="row"
                    fxFlex="100"
                    [ngClass]="{
                      hidden: isSmallWindowSize || lead?.isUberPickup ? !showQuoteDetails : false,
                      discount: lead?.discount?.valid,
                    }"
                  >
                    @if (lead && pricing && lead?.specification) {
                      <rspl-donation-estimate
                        fxFlex="100"
                        type="initial"
                        [pricing]="pricing"
                        [specification]="lead?.specification"
                        [showZeros]="false"
                        [editable]="charity?.meta?.onlySmallItems || !paymentSetupInitialized ? false : true"
                        [showUnitPrices]="false"
                        [bookingFee]="lead?.pricing.bookingFee"
                        [showTodaysCharges]="!lead?.discount?.valid"
                        [showDiscount]="lead?.discount?.valid"
                        [leadOrDonation]="lead"
                        (onSpecificationChange)="onSpecificationChange()"
                        totalLabel="Estimated Pickup Cost (Due On-Site)"
                        bookingLabel="Booking Fee (Due Today)"
                        [isCalculating]="isCalculatingPrice"
                      ></rspl-donation-estimate>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
          <!--  ********************************** desktop RIGHT section start ********************************  -->
          <div fxLayout="column" fxLayoutGap="15px" fxFlex="100" fxFlex.gt-sm="40" style="width: 100%">
            @if (!isSmallWindowSize && lead?.discount?.valid && !lead?.isUberPickup) {
              <div fxLayout="row" fxLayoutAlign="space-between">
                <span class="booking-fee-label">Today's charges</span>
                <span class="booking-fee-label">{{ lead?.pricing.bookingFee || 0 | currency }}</span>
              </div>
            }

            <ng-container [ngTemplateOutlet]="Checkbox"></ng-container>

            <div [ngClass]="{ 'stripe-wrarapper': showCOFform || gratuity }">
              <ng-container [ngTemplateOutlet]="STRIPE"></ng-container>
              @if (isLoaded || !(showCOFform || gratuity)) {
                <div
                  fxLayoutAlign="center center"
                  fxLayout="column"
                  class="submit-button-wrapper"
                  [ngStyle]="{ 'margin-top.px': showCOFform || gratuity ? 0 : 50 }"
                >
                  <button
                    class="submit-button primary-page-btn success-btn btn-block"
                    id="submitDonationButton"
                    (click)="confirmPayment()"
                    [ladda]="isSubmitting"
                    [disabled]="!isLoaded && (showCOFform || gratuity > 0)"
                  >
                    Reserve Your Pickup
                  </button>
                  @if (showCOFform || gratuity) {
                    <div fxLayout="row" fxLayoutAlign="center center" class="powered-by">
                      <mat-icon class="lock-icon">lock</mat-icon>
                      <span>Secure payments through</span>
                      <mat-icon class="stripe-icon" svgIcon="stripe" />
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    <div class="error-wrapper" fxLayoutAlign="center center">
      @if (error && !expired) {
        <p class="error">{{ error }}</p>
      }
      @if (expired) {
        <p class="error expired">Your link has expired, please contact support to get a new link</p>
      }
    </div>

    @if (!cardOnFile) {
      <div fxLayout="column" fxLayout.gt-sm="row" class="progress-wrapper">
        <app-create-progress fxFlex [step]="flowStep" [flowConfiguration]="flowConfiguration" />
      </div>
    }
  </div>
</ng-template>
